import { Module } from 'vuex';
import { IRootState } from '@/store';
import { ITimeOffRequestState } from './timeoff-request.types';
import {
  IMentionAttachmentCommentData,
  ITimeOffRequestData,
  IUserData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ITimeOffRequestState = {
  version: 1,
  count: 0,
  timeOffRequests: [] as ITimeOffRequestData[],
  unapprovedTimeOffRequests: [] as ITimeOffRequestData[],
  comments: [] as IMentionAttachmentCommentData[],
  lastCreatedRequestCommentId: null,
  mentionableUsers: [] as IUserData[],
  activities: [],
  lastPromise: null
};

const namespaced = true;

export const timeOffRequest: Module<ITimeOffRequestState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
